import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <article className="prose mx-auto max-w-2xl px-6 py-12 text-slate-700">
      <Link to="/" className="text-sm text-slate-500 hover:text-slate-700">
        ← Home
      </Link>
      <h1 className="mt-4 text-3xl font-semibold text-slate-900">Terms of use</h1>
      <p className="mt-2 text-sm text-slate-500">
        Beta — last updated June 2026. Friendly defaults; we'll formalize before charging anyone. Questions: <a href="mailto:support@adhoc.space" className="text-brand-600 hover:underline">support@adhoc.space</a>.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">What this is</h2>
      <p className="mt-2 text-sm">
        adhc.to is an invite-only URL shortener in beta. It's free during beta. There is no SLA, no guaranteed uptime, and features may change or break without notice.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Acceptable use</h2>
      <ul className="mt-2 list-disc space-y-1 pl-6 text-sm">
        <li>No malware, phishing, or content that's illegal where you live or where your audience lives.</li>
        <li>No deceptive or impersonating destination URLs.</li>
        <li>No bulk redirection of spam, scams, or harassment campaigns.</li>
        <li>No automated abuse of the API (we have rate limits and we'll use them).</li>
      </ul>
      <p className="mt-2 text-sm">
        We can suspend or remove links and accounts that violate the above, with notice when reasonable.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Your content</h2>
      <p className="mt-2 text-sm">
        You keep ownership of the links you create. We need permission to host them and to redirect visitors to your destinations; that's the whole product. You can delete a link any time.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">No warranty</h2>
      <p className="mt-2 text-sm">
        Beta software is provided "as is." We try hard, but things will sometimes break. Don't use adhc.to for safety-critical or revenue-critical short links yet.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Liability</h2>
      <p className="mt-2 text-sm">
        To the extent allowed by law, our total liability for any claim related to adhc.to during beta is limited to what you paid us (i.e. zero).
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Changes</h2>
      <p className="mt-2 text-sm">
        We'll email beta users (and update this page) before any material change to these terms.
      </p>
    </article>
  );
}
